var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MEDIUM_CLASS, MEDIUM_SIZE, useClassNames, useElementWidth, } from '../../util/screen';
import { FiltersModal } from './filters-modal';
import { useMemo } from 'react';
import { FiltersRow } from './filters-row';
import styled from 'styled-components';
import { XIcon } from './icons';
var SelectedOptionsContainer = styled.div({
    display: 'flex',
    marginTop: '24px',
    flexWrap: 'wrap',
});
var SelectedOptionContainer = styled.div({
    fontWeight: 'bold',
    display: 'flex',
    fontFamily: 'var(--font-family-primary)',
    lineHeight: 'normal',
    alignContent: 'baseline',
    padding: '15px 12px 15px 18px',
    backgroundColor: '#595959',
    color: '#fff',
    border: 'none',
    '&:not(:first-child)': {
        marginLeft: '15px',
    },
});
var SelectedOptionLabel = styled.div({
    cursor: 'default',
});
var SelectedOptionCloseButton = styled.button((_a = {
        cursor: 'pointer',
        border: 'none',
        backgroundColor: '#595959',
        color: '#fff',
        ':active': {
            backgroundColor: '#2b2a2a',
        }
    },
    _a["&.".concat(MEDIUM_CLASS)] = {
        borderRadius: '4px',
        justifyContent: 'center',
    },
    _a));
export var Filters = function (_a) {
    var filters = _a.filters, value = _a.value, onChange = _a.onChange, appElementSelector = _a.appElementSelector;
    var _b = useElementWidth(), ref = _b.ref, width = _b.width;
    var classNames = useClassNames(width);
    var selector = useMemo(function () {
        if (width < MEDIUM_SIZE) {
            return (_jsx(FiltersModal, { filters: filters, value: value, onChange: onChange, className: classNames, appElementSelector: appElementSelector }, void 0));
        }
        return (_jsx(FiltersRow, { filters: filters, value: value, onChange: onChange, className: classNames }, void 0));
    }, [width, filters, value, onChange, classNames, appElementSelector]);
    return (_jsxs("div", __assign({ ref: ref }, { children: [selector, _jsx(SelectedOptionsContainer, { children: value.map(function (option) { return (_jsxs(SelectedOptionContainer, { children: [_jsx(SelectedOptionLabel, { children: option.name }, void 0), _jsx(SelectedOptionCloseButton, __assign({ "aria-label": "remove", onClick: function () {
                                return onChange(value.filter(function (item) { return item.id !== option.id; }));
                            } }, { children: _jsx(XIcon, { color: "#fff" }, void 0) }), void 0)] }, option.id)); }) }, void 0)] }), void 0));
};
